import React, { useEffect } from 'react';
import { useDrawerNavigation } from '../../contexts/DrawerNavigationContext';
import PostInsightsDrawer from './PostInsightsDrawer';
import BrandDetailsDrawer from './BrandDetailsDrawer';
import NewsletterPostInsightsDrawer from '../newsletter/NewsletterPostInsightsDrawer';

const NavigationDrawerManager: React.FC = () => {
  const { state, closeAll } = useDrawerNavigation();

  // Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // ESC key to close drawers
      if (event.key === 'Escape') {
        closeAll();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [closeAll]);

  if (!state.current.type) {
    return null;
  }

  return (
    <>
      {/* Render background drawer if it exists in history */}
      {state.history.length > 0 && state.history[state.history.length - 1].type === 'post-insights' && (
        <PostInsightsDrawer
          isOpen={true}
          onClose={closeAll}
          post={state.history[state.history.length - 1].data}
        />
      )}

      {/* Render current drawer */}
      {state.current.type === 'post-insights' && (
        <PostInsightsDrawer
          isOpen={true}
          onClose={closeAll}
          post={state.current.data}
        />
      )}
      {state.current.type === 'brand-details' && (
        <BrandDetailsDrawer
          isOpen={true}
          onClose={closeAll}
          brand={state.current.data}
        />
      )}
      {state.current.type === 'newsletter-post-insights' && (
        <NewsletterPostInsightsDrawer
          isOpen={true}
          onClose={closeAll}
          post={state.current.data}
        />
      )}
    </>
  );
};

export default NavigationDrawerManager;